import {
  shorthands,
  makeStyles,
  mergeClasses,
  useButtonStyles_unstable,
} from "@fluentui/react-components";
import { isNextStyleEnabled } from "@1js/acui-theme";
import type { RibbonButtonState } from "./RibbonButton.types";
import {
  useCommonRibbonButtonStyles,
  getRibbonButtonSizedStyles,
} from "../../next/commonRibbonButtonStyles.styles";

const useRootStyles = makeStyles({
  small: {
    ...shorthands.padding("1px"),
    minHeight: "24px",
    minWidth: "24px",
  },
  large: {
    height: "72px",
    paddingTop: "3px",
    paddingRight: "1px",
    paddingBottom: "1px",
    paddingLeft: "1px",
  },
});

const useRootStylesNext = makeStyles({
  small: {
    minHeight: "24px",
    minWidth: "24px",
  },
  large: {
    height: "72px",
  },
});

export const useRibbonButtonCustomStyles = (state: RibbonButtonState) => {
  const rootStyles = useRootStyles();
  const nextStyles = useRootStylesNext();

  if (isNextStyleEnabled()) {
    state.root.className = mergeClasses(
      getRibbonButtonSizedStyles(state.size, nextStyles),
      state.root.className
    );
  } else {
    state.root.className = mergeClasses(
      getRibbonButtonSizedStyles(state.size, rootStyles),
      state.root.className
    );
  }

  useCommonRibbonButtonStyles(state as RibbonButtonState);
};

export const useRibbonButtonStyles = (
  state: RibbonButtonState
): RibbonButtonState => {
  useRibbonButtonCustomStyles(state);

  useButtonStyles_unstable(state);

  return state;
};
